/**
 *
 */

import React, { useState, useEffect } from "react";
import ManageMaintenance from "../../components/module/Maintenance/ManageMaintenance/ManageMaintenance";

/* Import configuration starts */
import { useDispatch, useSelector } from "react-redux";
/* Import configuration ends */

/* Import redux slices component starts */
import { getMaintenanceList } from "../../setup/store/slices/maintenanceSlice";

/* Import redux slices component ends */

/* Import react bootstrap component starts */
/* Import react bootstrap component ends */

/* Import image and SVG starts */
/* Import image and SVG ends */

/* Import local pages and component starts */
import BreadCrumb from "../../components/ui/other/BreadCrumb/BreadCrumb";
/* Import local pages and component ends */

/* Component starts */
const ManageMaintenancePage = (props) => {
  /* Props destructuring starts */
  const {} = props;
  /* Props destructuring ends */

  /* Component states and useRef declaration starts */
  /* Component states and useRef declaration ends */

  /* Other hooks declaration starts */
  const dispatch = useDispatch();

  // Redux Selector
  const maintenanceList = useSelector(getMaintenanceList);
  // console.log(maintenanceList,"MAIN");
  /* Other hooks declaration ends */

  /* Component variable declaration / object destructure starts */
  /* Component variable declaration / object destructure ends */

  /* Component function definition starts */
  /* Component function definition ends */

  /* Component useEffect starts */
  /* Component useEffect ends */

  /* ************* Component rendering. JSX code ************* */
  return (
    <>
      <BreadCrumb type="manage_maintenance" />
      <div>
        <ManageMaintenance maintenances={maintenanceList} />
      </div>
    </>
  );
};
/* Component ends */

export default ManageMaintenancePage;
